export class SousBien {
    id: number
    name: string;
    website: string;
    category: string;
    image_url: string;
    description: string
    prix: string
    imagesList:string[]
    role:string
}